<template>
    <div>
        <div v-if="!isLoading" class="">
            <div v-if="item" class="">
                <div class="row">
                    <div class="col-12">
                        <div v-if="item.status_info"  class="alert alert-warning mb-3 d-flex align-items-center" role="alert">
                            <svg style="width: 14px;" fill="#bf5b00" xmlns="http://www.w3.org/2000/svg" class="bi flex-shrink-0 me-2" viewBox="0 0 16 16"
                                role="img" aria-label="Warning:">
                                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                            </svg>
                            <div>
                                {{ item.status_info }}
                            </div>
                        </div>
                        <div v-if="item.status == 'completed'" class="card mb-4 shadow-sm">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h5 class="card-title mb-0">Verification Result</h5>
                                <div class="dropdown dropstart no-arrow">
                                    <button class="dropdown-toggle btn btn-sm btn-light" type="button" role="button"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="ri-more-2-fill"></i>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <button @click.prevent="printReceipt()" class="dropdown-item" type="button">
                                                Print Result </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card-body">
                                <verification-result-card :item="item"/>
                            </div>
                        </div>
                        <div v-else-if="item.status == 'pending' && item.verification && item.verification.status == 'ongoing'" class="mb-4">
                            <div  class="bd-callout mt-0 bd-callout-warning position-relative" style="z-index:2;">
                                <h5>Complete your verification now!</h5>
                                <div>
                                    <p class="mb-1">
                                        <span>Your verification is pending, you can proceed to complete this verification now.</span>
                                    </p>
                                    <div class="d-grid d-sm-flex gap-3 pt-3">
                                        <button @click.prevent="popupModalVerify = true" class="btn btn-primary">Complete Verification</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else  class="alert alert-warning mb-3 d-flex align-items-center" role="alert">
                            <svg style="width: 14px;" fill="#bf5b00" xmlns="http://www.w3.org/2000/svg" class="bi flex-shrink-0 me-2" viewBox="0 0 16 16"
                                role="img" aria-label="Warning:">
                                <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                            </svg>
                            <div>
                                NO RESULT FOUND - This verification currently has the status "{{ item.status }}"
                            </div>
                        </div>
                        <div v-if="item.verification" class="mb-4">
                            <div class="card mb-0 overflow-hidden">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                    <h5 class="card-title mb-0">Verification Details</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row g-3 g-lg-4">
                                        <div class="col-sm-4">
                                            <label class="small text-muted">Verification number</label>
                                            <p class="mb-0">{{ item.verification.friendly_id }}</p>
                                        </div>
                                        <div class="col-sm-4">
                                            <label class="small text-muted">Verification status</label>
                                            <p class="mb-0"><span v-html="statusBadge(item.verification.status)"> </span></p>
                                        </div>
                                        <div class="col-sm-4">
                                            <label class="small text-muted">Date Invited</label>
                                            <p class="mb-0">{{ $filters.date(item.created_at) }}</p>
                                        </div>
                                        <div class="col-sm-8">
                                            <label class="small text-muted">Title</label>
                                            <p class="mb-0">{{ item.verification.title }}</p>
                                        </div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 text-muted">Scheduled start date</label>
                                            <p class="mb-0 mt-2 pt-1">{{ $filters.date(item.verification.start_at, 2) }}</p>
                                        </div>
                                        <div class="col-sm-6">
                                            <label class="mb-0 text-muted">Verification deadline</label>
                                            <p class="mb-0 mt-2 pt-1">{{ $filters.date(item.verification.end_at,2) }}</p>
                                        </div>
                                        <div v-if="item.verification.description" class="col-12">
                                            <label class="small text-muted">Description</label>
                                            <div v-html="preText(item.verification.description)" class="mb-0"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <b-modal size="lg" hide-footer v-model="popupModalVerify" body-class="shadow-lg" title="Complete your verification">
                    <verification-form v-if="popupModalVerify" @closeMe="initializeAll();"
                    :verification="item" @completed="initializeAll(); fetchItem(false)"  />
                </b-modal>
            </div>
        </div>
        <CommonSpinner v-else />
    </div>
</template>

<script>
import VerificationForm from '@/components/forms/VerificationForm.vue'
import VerificationResultCard from '@shared/components/cards/VerificationResultCard.vue'

export default {
    name: "verification-show",
    components: {
        VerificationForm,
        VerificationResultCard
    },
    props: {
        quickView: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isLoading: true,
            popupModalVerify: false,
            item: null,
        }
    },
    watch: {
        '$route.params.verificationId': function (id) {
            if (id) this.fetchItem()
        },
    },
    methods: {
        fetchItem(showLoader = true) {
            this.isLoading = showLoader
            this.$http.get(`/verification-results/${this.quickView ? this.quickView.id : this.$route.params.verificationId}/show`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.item = response.data.data
                    } else {
                        this.$router.push({ path: '/error-404' })
                    }
                })
        },
        printReceipt() {
            const payload = {
                url: `/verification-results/${this.item.friendly_id}/print-result`,
                data: {}
            }
            this.$store.dispatch("changeLoaderValue", true)
            this.pdfFileExport(payload)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue", false)
                }).catch((error) => {
                    this.$store.dispatch("changeLoaderValue", false)
                })
        },
        initializeAll() {
            this.popupModalVerify = false;
        }
    },
    created() {
        this.fetchItem()
    },
}

</script>
